import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useCallback } from 'react';

const KeycloakContext = createContext({
  keycloak: {},
  logout: void 0
});
const KeycloakProvider = ({
  keycloak,
  logout,
  children
}) => {
  const handleLogout = useCallback(async () => {
    try {
      await logout?.();
      await keycloak.logout({
        redirectUri: window.location.origin
      });
    } catch (error) {
      console.error(error);
    }
  }, [logout, keycloak]);
  return /* @__PURE__ */ jsx(KeycloakContext.Provider, { value: {
    keycloak,
    logout: handleLogout
  }, children });
};
const useKeycloak = () => useContext(KeycloakContext);

export { KeycloakContext, KeycloakProvider, useKeycloak };
